<template>
<div class="grid mt-4">	

<div class="col-12 ">

<span class="p-float-label">
<Dropdown :filter="true"  v-model="$store.state.calculations.selectednode.data.selected_custom_attribute_id" :options="custom_attributes" optionLabel="name" optionValue="id" class="w-full p-inputtext-sm" :id="$store.state.calculations.selectednode.id" @change="customAttributeSelected"/>
<label :for="$store.state.calculations.selectednode.id" class="text-primary">Bir Nitelik Seçin</label>
</span>
</div>

<div class="col-12 mt-4" v-if="selectedattribute">
<label  class="text-primary ">Modül Çıktıları</label>
</div>

<div class="col-12 mt-2" v-if="selectedattribute">

<template v-if="selectedattribute.type=='string'">
<InputText  type="text" v-model="$store.state.calculations.selectednode.data.selected_value" class=" p-inputtext-sm mr-2"   /> 

<span class="text-primary">terimini </span>
<Dropdown :filter="false"  v-model="$store.state.calculations.selectednode.data.selected_operator" :options="text_options" optionLabel="name" optionValue="id" class=" p-inputtext-sm ml-2" />
</template>


<template v-if="selectedattribute.type=='number'">
<span class="text-primary">Girilen değer</span>
<InputText  type="number" v-model="$store.state.calculations.selectednode.data.selected_value" class="ml-2 p-inputtext-sm"   />  
<Dropdown :filter="false"  v-model="$store.state.calculations.selectednode.data.selected_operator" :options="number_options" optionLabel="name" optionValue="id" class=" p-inputtext-sm ml-2" />
</template>


<template v-if="selectedattribute.type=='boolean'">
<Dropdown :filter="false"  v-model="$store.state.calculations.selectednode.data.selected_value" :options="boolean_options" optionLabel="name" optionValue="id" class=" p-inputtext-sm " />	<span class="text-primary">olarak işaretliyse</span>
</template>


<template v-if="selectedattribute.type=='select'">
<Dropdown :filter="false"  v-model="$store.state.calculations.selectednode.data.selected_value" :options="select_options" optionLabel="name" optionValue="id" class=" p-inputtext-sm mr-2" />	<span class="text-primary">olarak işaretliyse	</span>
</template>


</div>


</div>	
</template>

<script>
export default {

  name: 'CustomAttributeDataNode',
  props:["custom_attributes"],
  data () {
    return {
    	text_options:    	[
    	{name:"içermiyorsa",id:"doesnotinclude"},
    	{name:"içeriyorsa",id:"includes"}
    	],
    	number_options:    	[
    	{name:"değerinden küçük",id:"lowerthan"},
    	{name:"değerine eşit",id:"equalto"},
    	{name:"değerinden büyük",id:"higherthan"},
    	],
    	boolean_options:    	[
    	{name:"açık",id:"true"},
    	{name:"kapalı",id:"false"},
    	],
    	select_options:[],
    }
  },
  computed:{
  	selectedattribute()
  	{  		
  		if(this.$store.state.calculations.selectednode && this.$store.state.calculations.selectednode.data.selected_custom_attribute_id)
  		{
  			console.log("ghj")
  			let attribute = this.custom_attributes.find((item)=>{return item.id  == this.$store.state.calculations.selectednode.data.selected_custom_attribute_id})
  			if(attribute.type=="select")
  			{
  				this.select_options = attribute.options
  			}
  			return attribute
  		}
  		return null
  	}
  },
  methods:{
    customAttributeSelected()
    {
      this.$store.state.calculations.selectednode.data.selected_value = null
    }
  }
}
</script>

<style lang="css" scoped>
</style>